export const API_MAI_FALI = "https://nusafua-adminduk.rotendaokab.go.id/api/";
//"http://localhost:5000/api/"
//'https://nusafua-adminduk.rotendaokab.go.id/api/';
//'http://localhost:4000/api/';

export const PERANGKAT_DAERAH = API_MAI_FALI + "dinas/";
export const ANALISIS_JABATAN = API_MAI_FALI + "anjab/";

export const EFEKTIFITAS = API_MAI_FALI + "efektifitas/";

export const ADMINS_LOGIN = API_MAI_FALI + "users/admin/login";
export const ADMINS_LOGOUT = API_MAI_FALI + "users/admin/logout";
export const ADMINS_TOKEN = API_MAI_FALI + "admin/token";
export const POST_ANJAB = API_MAI_FALI + "post/anjab/";
export const GET_ANJAB = API_MAI_FALI + "progress/anjab/";

export const ANALISIS_BEBAN_KERJA = API_MAI_FALI + "abk/";
export const POST_ABK = API_MAI_FALI + "post/abk/";
export const GET_ABK = API_MAI_FALI + "progress/abk/";

export const USERS = API_MAI_FALI + "users/";
export const LOG_APP = API_MAI_FALI + "logapp/";
export const GET_NOTIF = API_MAI_FALI + "notifikasi/";
export const GET_AKTIVITY = API_MAI_FALI + "useraktivity/";

// Data Disabilitas endpoints
export const DATA_DISABILITAS = API_MAI_FALI + "data-disabilitas/";
export const DATA_DISABILITAS_STATISTIK =
  API_MAI_FALI + "data-disabilitas/statistik/";
export const DATA_DISABILITAS_GROUP = API_MAI_FALI + "data-disabilitas/group/";

export const API_TIMEOUT = 120000;
